import React from "react";
import { Typography, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Contact.css";

const { Title } = Typography;

function Contact() {
  return (
    <div className="contact-icons">
      <a href="mailto:leanntai@mit.edu">
        <FontAwesomeIcon icon="fa-solid fa-envelope" className="contact-icon" />
      </a>
      <a href="https://github.com/taipioca">
        <FontAwesomeIcon icon="fa-brands fa-github" className="contact-icon" />
      </a>
      <a href="https://linkedin.com/in/leanntai">
        <FontAwesomeIcon
          icon="fa-brands fa-linkedin"
          className="contact-icon"
        />
      </a>
    </div>
  );
}

export default Contact;
